import {
  FileUpIcon,
  GraduationCapIcon,
  HighlighterIcon,
  SquareCheckBigIcon,
} from "lucide-react";
import { QuestionAnswerFlashcardToolbarIcon } from "../pdf/pdf-toolbar-icons";
import { cn } from "@/lib/utils";
export const UploadFeatureIcon = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 bg-teal-50 border border-teal-200 p-2 rounded-xl",
        className
      )}
    >
      <FileUpIcon className="w-icon-lg h-icon-lg text-teal-800 flex-none" />
    </div>
  );
};

export const QuizFeatureIcon = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 bg-green-50 border border-green-200 p-2 rounded-xl",
        className
      )}
    >
      <SquareCheckBigIcon className="w-icon-lg h-icon-lg text-green-800 flex-none" />
    </div>
  );
};

export const HighlightFeatureIcon = ({
  className,
  color = "teal",
}: {
  className?: string;
  color?: "teal" | "violet";
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 bg-violet-50 border border-violet-200 p-2 rounded-xl",
        color === "violet"
          ? "bg-violet-50 border-violet-200"
          : "bg-teal-50 border-teal-200",
        className
      )}
    >
      <HighlighterIcon
        className={cn(
          "w-icon-lg h-icon-lg flex-none",
          color === "violet" ? "text-violet-800" : "text-teal-800"
        )}
      />
    </div>
  );
};

export const StudyFeatureIcon = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 bg-sky-50 border border-sky-200 p-2 rounded-xl",
        className
      )}
    >
      <GraduationCapIcon className="w-icon-lg h-icon-lg text-sky-800 flex-none" />
    </div>
  );
};

export const FlashcardFeatureIcon = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 bg-yellow-50 border border-yellow-200 p-2 pt-1.5 pe-1.5 rounded-xl",
        className
      )}
    >
      <QuestionAnswerFlashcardToolbarIcon className="fill-yellow-800" />
    </div>
  );
};
